import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Container from '../container';
import MenuButton from './MenuButton';
import { getClassName } from '../../../utils/ui/classes';

const Navbar = ({
  showLeftMenuToggle,
  mainNavOpen,
  children,
  renderRightNav,
  renderMobileNav,
  logo,
  onToggleOpen,
}) => {
  const [open, setOpen] = useState(false);

  function toggleOpen() {
    setOpen(!open);
  }

  return (
    <nav className="fixed top-0 left-0 z-50 w-full bg-gray-800">
      <Container>
        <div className="flex items-center justify-between w-full h-16">
          <div className="flex items-center">
            {showLeftMenuToggle && (
              <div className="hidden lg:block">
                <MenuButton open={mainNavOpen} onClick={onToggleOpen} />
              </div>
            )}
            <div className="flex-shrink-0">{logo}</div>
            <div className="hidden lg:ml-4 xl:ml-6 lg:block">
              <div className="relative flex space-x-4">{children}</div>
            </div>
          </div>
          <div className="hidden lg:ml-6 lg:block">
            <div className="flex items-center">{renderRightNav()}</div>
          </div>
          <div className="flex lg:hidden">
            <MenuButton open={open} onClick={toggleOpen} />
          </div>
        </div>
        <div
          className={getClassName('lg:hidden', { block: open, hidden: !open })}
        >
          {renderMobileNav(toggleOpen)}
        </div>
      </Container>
    </nav>
  );
};

Navbar.propTypes = {
  showLeftMenuToggle: PropTypes.bool,
  children: PropTypes.any,
  renderRightNav: PropTypes.func,
  renderMobileNav: PropTypes.func,
};
Navbar.defaultProps = {
  showLeftMenuToggle: false,
  renderRightNav: () => {},
  renderMobileNav: () => {},
};

export default Navbar;
